module.exports = __webpack_public_path__ + "517ca529e380a171c68d90b82baac475.svg";